"use client";

import styles from "./mobile-searchbar.module.css";
import { useState } from "react";
import { useEffect } from "react";
import { GoSearch } from "react-icons/go";
import { useTranslations } from "next-intl";
import SearchModal from "./search-modal";
import { useScrollLock } from "@/hooks/use-scroll-lock";

export default function MobileSearchbar({
  sessionId,
}: {
  sessionId: string | null;
}) {
  const [showModal, setShowModal] = useState(false);
  const t = useTranslations("HomeMobileSearchbar");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 744) {
        setShowModal(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useScrollLock(showModal);

  return (
    <div className={styles.contentWrapper}>
      <button
        onClick={() => setShowModal(true)}
        className={styles.searchbarWrapper}
      >
        <GoSearch className={styles.searchIcon} />
        <span className={styles.searchWrapper}>
          <span className={styles.title}>{t("title")}</span>
        </span>
      </button>
      {showModal && (
        <SearchModal
          onClose={() => setShowModal(false)}
          sessionId={sessionId}
        />
      )}
    </div>
  );
}
